import type { ENV } from '@kolumboos/config';

type WebENV = Exclude<ENV, 'test'>;

interface Config {
  env: WebENV;
  mapsApiKey: string;
}

const getEnv = (): WebENV => {
  // USING PMS_ENV, NOT NODE_ENV !
  const env = process.env.REACT_APP_PMS_ENV;

  if (!['development', 'staging', 'production'].includes(env ?? '')) {
    console.warn('PMS_ENV is not a valid value, setting to: development');
    return 'development';
  }

  return env as WebENV;
};

export function getApiHost(): string {
  if (IS_STAGE) return 'https://pms-api-jtjmthxlbq-ew.a.run.app';
  if (IS_PROD) return `https://api.myothispms.com`;
  return 'http://localhost:3000';
}

const configs: { [key in WebENV]: Config } = {
  development: {
    env: 'development',
    mapsApiKey: 'AIzaSyDZYMiM-vGKvLQCs3G3_V_cY8W0BAE1fdA',
  },
  staging: {
    env: 'staging',
    mapsApiKey: 'AIzaSyAi70el4MwYOgDqLaizzwn6Sb0-_R30wkY',
  },
  production: {
    env: 'production',
    mapsApiKey: 'AIzaSyBJWvDg7ZRYdvN2WG8ix8LwukqPhLVevPY',
  },
};

const config = configs[getEnv()];

export const IS_DEV = config.env === 'development';
export const IS_STAGE = config.env === 'staging';
export const IS_PROD = config.env === 'production';

export const STORAGE_BUCKET_PREFIX = `pms-${
  config.env === 'development' ? 'dev' : config.env === 'staging' ? 'stage' : 'prod'
}`;

export default config;
